<template>
  <div class="video-tab-view-container">
    <video ref="videoPlayer" class="video-js"></video>
    <ul v-if="videos.length > 0" class="video-tab-view">
      <li v-for="video in videos" :key="video.id" @click="playVideo(video.url)">
        <img class="album" :src="video.firstFrame" alt="" />
        <img
          class="play"
          src="../../../assets/video/play_center@2x.png"
          alt=""
        />
      </li>
    </ul>
    <div v-else-if="alreadyChange" class="un-upload">
      <img
        class="icon"
        src="../../../assets/personal/un_upload_video@2x.png"
        alt=""
      />
      <p>ta还没有上传视频</p>
    </div>
    <ml-loading v-else />
  </div>
</template>

<script>
import videojs from "video.js";
import "video.js/dist/video-js.css";

export default {
  name: "VideoTabView",
  props: {
    videos: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      alreadyChange: false,
      player: null,
      videoOptions: {
        autoplay: true,
        controls: true
      }
    };
  },
  watch: {
    videos() {
      this.alreadyChange = true;
    }
  },
  methods: {
    playVideo(url) {
      console.log(this.$refs["videoPlayer"]);
      this.destroyPlayer();
      this.player = videojs(
        this.$refs["videoPlayer"],
        {
          autoplay: true,
          controls: false,
          isFullscreen: true,
          sources: url
        },
        function() {
          console.log();
        }
      );
    },
    destroyPlayer() {
      if (this.player) {
        this.player.dispose();
      }
    }
  },
  beforeDestroy() {
    this.destroyPlayer();
  }
};
</script>

<style lang="scss" scoped>
.video-js {
  display: none;
}
</style>

<style lang="scss" scoped>
.video-tab-view-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.video-tab-view {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: auto;
  grid-gap: 10px;
  li {
    position: relative;
    width: 168px;
    height: 228px;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0) 69%,
      rgba(0, 0, 0, 1) 100%
    );
    border-radius: 6px;
    overflow: hidden;
    .album {
      width: 100%;
      height: 100%;
    }
    .play {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 40px;
      height: 40px;
      transform: translate(-50%, -50%);
    }
  }
}
.un-upload {
  flex: 1;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  .icon {
    width: 76px;
    height: 76px;
  }
  p {
    margin: 24px 0;
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    line-height: 20px;
  }
}
</style>
